import { Flex, Text } from "@mantine/core";
import React from "react";

const Error = ({ message }) => {
  return (
    <Flex justify={"center"} align={"center"} h={"100%"} px={12}>
      <Text size="lg" c="#ffffff" fw={600} ta={"center"}>
        {message}
      </Text>
      {/* You can provide additional UI or actions here */}
    </Flex>
  );
};

export default Error;
